import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "../../../../utils/onboardingI18n";
import { Button } from "antd";
import KycForm from "../../kyc/components/KycForm";
import KycRequested from "../../kyc/components/KycRequested";
import KycVerified from "../../kyc/components/KycVerified";
import { setUserDetails } from "../../../../store/Slices/userSlice";
import { CheckKycStatusApi } from "../../../../api/request/kyc";
import { updateEkycStatus } from "../../../../api/request/individualOnboarding";
import { handleApiError } from "../../../../utils/handleApiError.js";
import toast from "react-hot-toast";

const EKYC = ({ onNext, onPrevious, isSubmitted }) => {
  const { t } = useTranslation("onBoarding");
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);
  const [pending, setPending] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  useEffect(() => {
    if (userDetails?.kycStatus === "Pending") {
      setPending(true);
    }
  }, [userDetails?.kycStatus]);

  const checkKycStatus = async () => {
    try {
      let params = {
        UserId: userDetails?._id || userDetails?.id,
      };
      const { data } = await CheckKycStatusApi(
        new URLSearchParams(params).toString()
      );
      if (data?.success) {
        dispatch(
          setUserDetails({ ...userDetails, kycStatus: data?.data?.kycStatus })
        );
        if (data?.data?.kycStatus === "Pending") {
          setPending(true);
        }
        if (data?.data?.kycStatus === "Rejected") {
          setPending(false);
        }
        if (data?.data?.kycStatus === "Approved") {
          // KYC is approved, can proceed to next step
          // Note: KycVerified will be shown, user can manually proceed
        }
      }
    } catch (error) {
      console.error("Error checking KYC status:", error);
    }
  };

  useEffect(() => {
    if (userDetails?._id || userDetails?.id) {
      checkKycStatus();
    }
  }, [userDetails?._id, userDetails?.id]);

  const handleNext = async () => {
    try {
      setIsSubmitLoading(true);
      
      const payload = {
        isKYCCompleted: true,
      };

      const { data } = await updateEkycStatus(payload);

      if (data?.success) {
        toast.success(data?.message || t("KYC status updated successfully"));
        onNext();
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const renderKycContent = () => {
    if (pending) {
      return <KycRequested setPending={setPending} redirectOnApproved={false} />;
    }
    if (userDetails?.kycStatus === "Approved") {
      return (
        <div className="w-full">
          <KycVerified />
          <div className="flex justify-end gap-4 mt-6 px-6 pb-6">
            {onPrevious && (
              <Button
                onClick={onPrevious}
                size="large"
                disabled={isSubmitted}
              >
                {t("Previous")}
              </Button>
            )}
            <Button
              type="primary"
              size="large"
              loading={isSubmitLoading}
              disabled={isSubmitted || isSubmitLoading}
              onClick={handleNext}
            >
              {isSubmitLoading ? t("Updating...") : t("Next")}
            </Button>
          </div>
        </div>
      );
    }
    return <KycForm />;
  };

  return (
    <div className="w-full">
      {renderKycContent()}
    </div>
  );
};

export default EKYC;

